import { render } from "./menu-block.vue?vue&type=template&id=ab39f560"
import script from "./menu-block.vue?vue&type=script&lang=js"
export * from "./menu-block.vue?vue&type=script&lang=js"

import "./menu-block.vue?vue&type=style&index=0&id=ab39f560&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__